import API from '../api';

export default class ChallengeSubmissionService {
  constructor() {
    this.API = new API();
  }

  archiveSubmission = (accountId, contestId) => this.API.delete(`/challengeSubmission/${accountId}/${contestId}`);
}
